import { ComputedRef } from 'vue'

import { GetCommentaryViewModel } from '@/presentation/viewmodels/commentary/getCommentaryViewModel'

export class GetCommentaryPresenter {
  private viewModel: GetCommentaryViewModel

  constructor(viewModel: GetCommentaryViewModel) {
    this.viewModel = viewModel
  }

  get isLoading(): ComputedRef<boolean> {
    return this.viewModel.isLoading
  }

  get error(): ComputedRef<Error | null> {
    return this.viewModel.error
  }

  async getCommentary(
    displayLanguage: string,
    problemId: string,
    pattern: string,
    type: string,
    filter: string
  ): Promise<void> {
    await this.viewModel.getCommentary(displayLanguage, problemId, pattern, type, filter)
  }
}
